import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListaContratosExpo23 from '../../../components/contratos/listar/expomacuco';


function ListaContratosExpo23Screen() {
    return (
        <Fragment>
            <Head titulo="Contratos Firmados para a Expo Macuco 2023" />
            <Header />
            <Container>
                <ListaContratosExpo23 />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaContratosExpo23Screen;